import _t from 'i18n!nls/product-card';

export type MarketingTagCategory =
  'bestseller' | 'top-ai-program' | 'trending-now' | 'recently-updated' | 'hot-new-release';

export type MarketingStatusTag = {
  tag: string;
  tagName: string;
  category: MarketingTagCategory;
};

type MarketingTagSlugList = readonly [MarketingTagCategory, readonly string[]];

const BESTSELLER_SLUGS: readonly string[] = [
  'google-project-management',
  'python',
  'excel',
  'google-it-automation',
  'microsoft-365-fundamentals',
  'project-management-certificate',
  'wharton-business-foundations',
  'data-analytics-certificate',
  'financial-markets-global',
  'finance-accounting',
  'google-business-intelligence',
  'digital-marketing-certificate',
  'arizona-state-university-tesol',
  'it-support-certificate',
  'software-engineering-fundamentals',
  'positivepsychology',
  'python-3-programming',
  'it-automation-certificate',
  'aws-cloud-solutions-architect',
  'introduction-psychology',
  'nasm-personal-fitness-trainer',
  'supply-chain-management',
  'mathematics-for-machine-learning-and-data-science',
  'wharton-business-financial-modeling',
  'strategic-leadership',
  'mathematics-machine-learning',
  'social-science',
  'google-people-management-essentials',
  'business-analytics',
  'finance-quantitative-modeling-analysts',
  'business-strategy',
  'hsk-learn-chinese',
  'gis',
  'ibm-management-consultant',
  'finance-and-financial-markets',
  'people-and-soft-skills-for-professional-success',
  'six-sigma-fundamentals',
  'genomic-data-science',
  'cbrops',
  'ibm-technical-support',
  'hrci-human-resource-associate-international',
  'aws-cloud-practitioner-essentials',
  'google-cloud-cybersecurity-certificate',
  'data-engineering',
  'airbus-supply-chain-specialist',
  'stanford-statistics',
  'modern-contemporary-art-design',
  'the-science-of-well-being',
  'ibm-digital-marketing-and-growth-hacking',
  'uva-darden-digital-product-management',
  'anatomy',
  'workday-basics-series',
  'learning-how-to-learn',
  'sciwrite',
  'programming-python-java',
  'canva-essentials',
  'wharton-success',
  'business-english',
  'investment-management',
  'johns-hopkins-medical-office-manager',
  'bi-essentials-for-finance-professionals-powerbi',
  'ibm-ethical-hacking-with-open-source-tools',
  'medical-billing-coding-fundamentals',
  'digital-marketing',
  'tesol',
  'ibm-systems-and-solutions-architect',
  'seo',
  'microsoft-365-essentials-create-collaborate-and-deliver',
  'the-science-of-mind-and-decision-making',
  'microsoft-introduction-to-c-plus-plus-programming',
  'ux-design',
  'aapc-medical-biller',
  'data-science-python',
  'introduction-to-learning-experience-design',
  'improve-english',
  'negotiation-skills',
  'data-structures-algorithms',
  'public-speaking',
  'career-success',
  'data-science-fundamentals-python-sql',
  'influencing-storytelling-change-management',
  'thinklikeacfo',
  'jhu-data-science',
  'creative-writing',
  'accounting-assistant',
  'ibm-data-architect',
  'academic-english',
  'mathematics-engineers',
  'excel-data-analytics-visualization',
  'high-performance-leadership',
];

const TOP_AI_PROGRAM_SLUGS: readonly string[] = [
  'google-ai',
  'ai-essentials-google',
  'machine-learning-introduction',
  'ibm-generative-ai-engineering',
  'ai-healthcare',
  'ibm-rag-and-agentic-ai',
  'deep-learning',
  'ai-for-business-wharton',
  'prompting-essentials-google',
  'ai-engineer',
  'applied-artifical-intelligence-ibm-watson-ai',
  'ai-for-everyone',
  'microsoft-ai-product-manager',
  'ibm-ai-product-manager',
  'microsoft-sql-server',
  'prompt-engineering',
  'microsoft-ai-and-ml-engineering',
  'ibm-machine-learning',
  'introduction-to-generative-ai',
  'ai-foundations-for-everyone',
  'ai-foundations-business-professionals',
  'real-world-ai-for-everyone',
  'generative-ai-software-engineering',
  'ai-product-management-duke',
  'microsoft-365-copilot-for-productivity',
  'financialengineering',
  'aws-gen-ai-developer-advanced',
  'ai-agents-for-leaders',
  'ai-agents',
  'complete-claude-code-claude-cowork-masterclass',
  'claude-ai-tools-for-beginners',
  'generative-ai-for-software-development',
  'pytorch-for-deep-learning',
  'introduction-data-science',
  'ai-automation-engineer-n8n',
  'microsoft-generative-ai-engineering',
  'natural-language-processing',
  'build-anything-with-ai',
  'ai-financial-services-foundations-future-trends',
  'generative-ai-with-llms',
  'chatgpt-free-ai-tools-to-excel',
  'machine-learning-specialization',
  'generative-ai-engineering-with-llms',
  'microsoft-enterprise-ai-governance-ethics-and-security',
  'microsoft-genai-for-data-analysis',
  'ibm-deep-learning-with-pytorch-keras-tensorflow',
  'ai-for-medicine',
  'financialtechnology',
  'reinforcement-learning',
  'generative-ai-for-project-managers',
  'microsoft-copilot-your-everyday-ai-companion',
  'vibe-coding',
  'responsible-generative-ai',
  'mastering-claude-ai-prompting-apis-rag-and-mcp',
  'generative-ai-for-executives-and-business-leaders',
  'gemini-for-google-workspace',
  'generative-ai-for-software-developers',
  'tensorflow-in-practice',
  'generative-ai-for-human-resources',
  'google-ai-fundamentals',
  'computational-neuroscience',
  'microsoft-azure-ai-900-ai-fundamentals',
  'generative-ai-for-ui-ux-design',
  'aws-generative-ai-developers',
  'microsoft-ai-agents',
  'smarter-content-and-communications-with-microsoft-copilot',
  'large-language-model-operations',
  'ai-agents-python',
  'preparing-for-google-cloud-machine-learning-engineer-professional-certificate',
  'introduction-to-ai',
  'microsoft-powerbi-developer-and-architect',
  'organizational-strategy-generative-ai',
  'enterprise-ai-data-engineering-databricks',
];

const TRENDING_NOW_SLUGS: readonly string[] = [
  'facebook-social-media-marketing',
  'microsoft-junior-qa-software-tester',
  'microsoft-business-analyst',
  'american-english-pronunciation',
  'getting-started-with-google-workspace',
  'indigenous-canada',
  'introduction-to-business-strategy',
  'ibm-data-engineer',
  'intuit-bookkeeping',
  'sap-business-analyst',
  'social-impact-and-public-policy',
  'technical-support-fundamentals',
  'master-microsoft-office-365-power-platform',
  'sales-development-representative',
  'adp-payroll-specialist',
  'anxiety-mood-substance-addictive-behaviors',
  'ibm-cybersecurity-analyst',
  'pmp-exam-prep-certification-training',
  'meta-front-end-developer',
  'boost-your-leadership-impact',
  'regulatory-compliance',
  'foundations-of-cybersecurity',
  'xlpbi',
  'foundations-data',
  'foundations-of-digital-marketing-and-e-commerce',
  'good-with-words',
  'construction-management',
  'keller-williams-real-estate-agent',
  'adp-compensation-benefits-analyst',
  'ibm-business-analyst-professional-certificate',
  'microsoft-ai-business-professional',
  'mafash',
  'creative-design-tools-adobe-photoshop-illustrator-acrobat',
  'ace-health-coach',
  'meem-project-management',
  'ibm-applied-devops-engineering',
  'ibm-financial-planning-analysis-ai-skills',
  'leading-teams',
  'pearson-certified-associate-in-project-management-capm-exam',
  'aws-fundamentals',
  'microsoft-full-stack-developer',
  'introduction-to-cosmetic-science',
  'marketing-mix',
  'sap-technology-consultant',
  'microsoft-front-end-developer',
  'project-management-foundations',
  'clinical-trials-good-clinical-practice',
  'hrci-human-resources-professional',
  'ask-questions-make-decisions',
  'six-sigma-green-belt',
  'intermediate-grammar',
  'os-power-user',
  'excel-essentials',
  'java-developer',
  'ibm-full-stack-javascript-developer',
  'human-resource-management',
  'cvshealth-call-center-customer-service',
  'ibm-data-analyst-r-excel',
  'meta-full-stack-developer',
  'certificado-de-carrera-de-google-marketing-digital-e-e-commerce',
  'microsoft-power-bi-data-analyst',
  'preparing-data-for-analysis-with-microsoft-excel',
  'ibm-project-manager',
  'rust-programming',
  'learn-sql-basics-data-science',
  'python-for-applied-data-science-ai',
  'negotiation',
  'learn-english-beginning-grammar',
  'medicalterminology',
  'data-analysis-visualization-foundations',
  'psychological-research',
  'ibm-relational-database-administrator',
  'graphic-design',
  'packt-comptia-security-plus-certification-sy0-701-the-total-course',
  'ibm-ui-ux-designer',
  'computer-networking',
  'foundations-user-experience-design',
  'introduction-to-leadership-principles',
  'ibm-it-project-manager',
  'microsoft-excel-skills',
  'microsoft-data-analysis-sql-excel-powerbi',
  'generative-ai-for-leaders',
  'building-ai-agents-and-agentic-workflows',
  'generative-ai-for-everyone',
  'generative-ai-strategic-leader',
  'generative-ai-for-growth-marketing',
  'ai-governance-iso42001-readiness-grc-audit-legal',
  'microsoft-365-copilot',
  'mlops-machine-learning-duke',
  'microsoft-ai-transformation-leader',
];

const RECENTLY_UPDATED_SLUGS: readonly string[] = [
  'data-analytics',
  'google-cloud-data-analytics-certificate',
  'microsoft-program-management',
  'aws-cloud-technology-consultant',
  'meta-android-developer',
  'matlab-programming-engineers-scientists',
  'operations-research',
  'ai-builder',
  'computer-vision-cu',
  'snowflake-generative-ai',
  'digital-healthcare-informatics-and-ai',
  'aws-certified-ai-practitioner',
  'foundations-reinforcement-learning',
  'business-analytics-with-excel',
  'aws-generative-ai-applications',
  'edge-ai-mcu',
  'ai-in-law-research-risk-and-legal-drafting',
  'github',
  'artificial-intelligence-ethics',
  'genai-for-project-management',
  'microsoft-generative-and-agentic-ai-basics',
  'genai-for-business-process-automation',
  'ai-powered-customer-success',
  'applied-ai',
  'machine-learning-scikit-learn-pytorch-hugging-face',
  'packt-langchain-and-langgraph',
  'ai-powered-finance-forecasting-planning-and-reporting',
  'ai-for-hr',
  'ai-engineering',
  'create-and-enhance-visuals-with-ai',
  'build-genai-applications-and-agents',
  'photoshop-image-editing-compositing-and-ai',
  'oracle-cloud-and-ai',
  'data-science-beyond-the-basics-ml-and-ds',
  'microsoft-data-analysis-python-r',
  'ai-for-sales',
  'aimachinelearninginfinance',
  'google-data-analytics',
  'google-cybersecurity',
  'google-it-support',
  'google-digital-marketing-ecommerce',
  'google-ux-design',
  'ibm-data-analyst',
  'hrci-human-resource-associate',
  'ibm-full-stack-cloud-developer',
  'microsoft-it-support-specialist',
  'microsoft-cybersecurity-analyst',
  'microsoft-python-developer',
  'devops-and-software-engineering',
  'salesforce-sales-operations',
  'tableau-business-intelligence-analyst',
  'ibm-product-manager',
  'meta-back-end-developer',
  'microsoft-back-end-developer',
  'microsoft-project-management',
  'ibm-data-manager',
  'unilever-supply-chain-data-analyst',
  'bi-analyst',
  'facebook-marketing-analytics',
  'epic-games-game-design-professional-certificate',
  'meta-data-analyst',
  'amazon-junior-software-developer',
  'meta-database-engineer',
  'microsoft-public-relations',
  'ibm-data-science',
  'adobe-graphic-designer',
  'adobe-content-creator',
  'adobe-marketing-specialist',
  'google-advanced-data-analytics',
  'ibm-isc2-cybersecurity-specialist',
  'unilever-digital-marketing-analyst',
  'backend-javascript-developer',
  'fractal-data-science',
  'xbox-product-manager',
  'ibm-backend-development',
  'support-informatique-google',
  'generative-ai-educators',
  'ibm-ios-android-mobile-app-developer-pc',
  'meta-ios-developer',
  'tally-bookkeeper',
];

const HOT_NEW_RELEASE_SLUGS: readonly string[] = [
  'microsoft-excel-learn-with-projects',
  'ibm-lead-ai-transformation-strategy-governance-execution',
  'prompt-design-grounding-and-rag-with-vertex-ai',
  'financial-modeling-and-analysis',
  'critical-thinking-and-decision-science',
  'aws-supply-chain-specialist',
  'sql-data-analysis-business-insights',
  'coursera-social-media-marketing',
  'google-cloud-ai-agents-foundations-enterprise-scale',
  'master-productivity-and-data-skills-certification',
  'devops-engineering',
  'cfi-valuation-modeling',
  'personal-and-professional-development',
  'microsoft-365-and-agent-administration',
  'ai-mba',
  'instructional-design-digital-learning-strategy',
  'microsoft-hr-manager',
  'market-reseach-analyst',
  'ibm-ai-native-data-engineering',
  'astronomy-cosmology',
  'learn-english-now-basic-achievement',
  'certified-professional-coder-exam-preparation',
  'ai-agents-with-vertex-ai-reasoning-engine-and-agent-builder',
  'anti-money-laundering-and-transaction-compliance',
  'jb-python-development-essentials',
  'nociones-de-analisis-de-datos-con-excel-access-y-big-data',
  'practical-javascript-from-scratch-to-react',
  'aws-security-engineer-advanced',
  'digital-pedagogy-and-inclusive-learning-design',
  'microsoft-cybersecurity-architecture',
  'microsoft-fabric-data-engineer',
  'logistics-inventory-management',
];

// Program list as of August 2026
// @see https://docs.google.com/spreadsheets/d/1ii3J_KcVG1yYS-Jjx3zHyU0oC_fGY6INHq5Sh-XUwkk
export const MARKETING_TAG_SLUG_LISTS: readonly MarketingTagSlugList[] = [
  ['bestseller', BESTSELLER_SLUGS],
  ['trending-now', TRENDING_NOW_SLUGS],
  ['top-ai-program', TOP_AI_PROGRAM_SLUGS],
  ['recently-updated', RECENTLY_UPDATED_SLUGS],
  ['hot-new-release', HOT_NEW_RELEASE_SLUGS],
];

export const buildMarketingTagSlugMap = (
  lists: readonly MarketingTagSlugList[]
): {
  map: Record<string, MarketingTagCategory>;
  collisions: Array<{ slug: string; from: MarketingTagCategory; to: MarketingTagCategory }>;
} => {
  const map: Record<string, MarketingTagCategory> = {};
  const collisions: Array<{ slug: string; from: MarketingTagCategory; to: MarketingTagCategory }> = [];

  for (const [category, slugs] of lists) {
    for (const slug of slugs) {
      const existing = map[slug];
      if (existing && existing !== category) {
        collisions.push({ slug, from: existing, to: category });
      }
      map[slug] = category;
    }
  }

  return { map, collisions };
};

let marketingTagSlugMap: Record<string, MarketingTagCategory> | undefined;

const getMarketingTagSlugMap = (): Record<string, MarketingTagCategory> => {
  if (!marketingTagSlugMap) {
    // build a map if not cached
    marketingTagSlugMap = buildMarketingTagSlugMap(MARKETING_TAG_SLUG_LISTS).map;
  }
  return marketingTagSlugMap;
};

// Shared tag category colors. Values from the approved design.
export const topAiProgramColors = {
  backgroundColor: 'var(--cds-color-purple-100)',
  color: 'var(--cds-color-purple-950)',
};

export const recentlyUpdatedColors = {
  backgroundColor: 'var(--cds-color-feedback-background-success-weak)',
  color: 'var(--cds-color-feedback-success-hover)',
};

export const bestsellerColors = {
  backgroundColor: 'var(--cds-color-yellow-50)',
  color: 'var(--cds-color-yellow-750)',
};

export const trendingNowColors = {
  backgroundColor: 'var(--cds-color-red-100)',
  color: 'var(--cds-color-red-850)',
};

export const hotNewReleaseColors = {
  backgroundColor: 'var(--cds-color-red-100)',
  color: 'var(--cds-color-red-850)',
};

// tagName is kept as the pre-existing, stable analytics identifier for each category — it does
// not follow display-text casing changes, so tracking stays continuous with historical data.
const getMarketingTagContent = (category?: MarketingTagCategory): MarketingStatusTag | undefined => {
  switch (category) {
    case 'bestseller':
      return { tag: _t('Bestseller'), tagName: 'Bestseller', category };
    case 'top-ai-program':
      return { tag: _t('Top AI program'), tagName: 'Top AI Program', category };
    case 'trending-now':
      return { tag: _t('Trending right now'), tagName: 'Trending right now', category };
    case 'recently-updated':
      return { tag: _t('Recently updated'), tagName: 'Recently Updated', category };
    case 'hot-new-release':
      return { tag: _t('Hot new release'), tagName: 'Hot new release', category };
    default:
      return undefined;
  }
};

// Categories shown only to learners in the `merch-pills-card-and-xdp` experiment (CVR-2724, CVR-2736, CVR-2737).
const NEW_MERCH_PILL_CATEGORIES: readonly MarketingTagCategory[] = [
  'recently-updated',
  'bestseller',
  'hot-new-release',
];

export const isNewMerchPillCategory = (category?: MarketingTagCategory) =>
  category !== undefined && NEW_MERCH_PILL_CATEGORIES.includes(category);

// Pills that already say the program is new or fresh, so the "New" tag is redundant next to them.
const NEW_TAG_REDUNDANT_CATEGORIES: readonly MarketingTagCategory[] = ['recently-updated', 'hot-new-release'];

export const makesNewTagRedundant = (category?: MarketingTagCategory) =>
  category !== undefined && NEW_TAG_REDUNDANT_CATEGORIES.includes(category);

// Bestseller slugs that keep the legacy, unstyled Bestseller tag outside the experiment treatment (CVR-2736).
// Temporary: remove once the experiment ends.
const LEGACY_BESTSELLER_SLUGS: readonly string[] = [
  'google-people-management-essentials',
  'jhu-data-science',
  'software-engineering-fundamentals',
  'wharton-success',
  'data-science-fundamentals-python-sql',
  'programming-python-java',
];

export const isLegacyBestsellerSlug = (slug: string) => LEGACY_BESTSELLER_SLUGS.includes(slug);

type MarketingStatusTagOptions = {
  // The new merchandising pills are behind an experiment, so callers must opt in after reading it.
  includeNewMerchPills?: boolean;
};

export const getMarketingStatusTagForSlug = (
  slug: string,
  { includeNewMerchPills = false }: MarketingStatusTagOptions = {}
): MarketingStatusTag | undefined => {
  const category = getMarketingTagSlugMap()[slug];
  if (isNewMerchPillCategory(category) && !includeNewMerchPills && !isLegacyBestsellerSlug(slug)) {
    return undefined;
  }
  return getMarketingTagContent(category);
};
